import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import CalendarDay from './CalendarDay'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
}))

const CalendarRange = ({
  admin,
  data,
  config,
  choosenSlot,
  wrapTitle,
  onClickSlot,
  onEditDay,
}) => {
  const classes = useStyles()
  return (
    <div className={ classes.root }>
      {
        data.map((day, i) => {
          return (
            <CalendarDay
              key={ i }
              admin={ admin }
              data={ day }
              config={ config }
              choosenSlot={ choosenSlot }
              wrapTitle={ wrapTitle }
              onClickSlot={ onClickSlot }
              onEditDay={ onEditDay }
            />
          )
        })
      }
    </div>
  )
}

export default CalendarRange